import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-frequently-questions',
    templateUrl: './frequently-questions.component.html',
    styleUrls: ['./frequently-questions.component.css'],
    standalone: false
})

export class FrequentlyQuestionsComponent implements OnInit {

    @Input()
    faq: string;
    ConstsHelper = ConstsHelper;
    environment = environment;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit() {}

    openFaqContent(event) {
        const button = event.currentTarget;
        const divElement = button.nextElementSibling;

        if (divElement.hasAttribute('class') === true) {
            divElement.removeAttribute('class');
        } else {
            divElement.setAttribute('class', 'faq-content-open');
        }
    }

    sanitizeContent(text: any) {
        return this.sanitizer.bypassSecurityTrustHtml(text);
    }
}
